import { ele } from "cables-shared-client";
import api from "../../api.js";
import web from "../../index.js";

export default class PageTestRun
{
    constructor(targetElement)
    {
        let runId = targetElement.dataset.run;
        const loadingIndicator = ele.byId("loading");
        const runResultEl = ele.byId("run_results");

        if (loadingIndicator) ele.show(loadingIndicator);

        api.post("test/run/category/results", {
            "run": runId,
        }, (result) =>
        {
            if (loadingIndicator) ele.hide(loadingIndicator);
            if (result.data && Array.isArray(result.data))
            {
                const allEl = ele.byId("all");
                const failedEl = ele.byId("failed");
                const passedEl = ele.byId("passed");
                const errorEl = ele.byId("error");

                let passed = result.data.length;
                result.data.forEach((testResult) =>
                {
                    testResult.hideRunButton = true;
                    testResult.showTestInfo = true;
                    const rowHtml = web.getHandleBarHtml("test_resultrow", testResult);
                    allEl.innerHTML += rowHtml;
                    if (testResult.status === "passed")
                    {
                        passed--;
                        passedEl.innerHTML += rowHtml;
                    }
                    else if (testResult.status === "failed")
                    {
                        failedEl.innerHTML += rowHtml;
                    }
                    else if (testResult.status === "error")
                    {
                        errorEl.innerHTML += rowHtml;
                    }
                });
                if (runResultEl)
                {
                    runResultEl.innerText = " - " + passed + "/" + result.data.length;
                    ele.show(runResultEl);
                }
            }
        });
    }
}
